export default __webpack_public_path__ + "static/media/video-poster.5d441ec0.png";